/** Slice an ISO datetime/date string to YYYY-MM-DD (the form a native
 *  <input type="date"> value expects, and the granularity the review compares
 *  staged vs committed actuals at). Empty string for null/undefined. */
export const iso10 = (s: string | null | undefined): string => (s ? s.slice(0, 10) : "");

const isWeekendDow = (dow: number): boolean => dow === 0 || dow === 6;

/** Whether an ISO date falls on a weekend (the one weekend rule all the
 *  review's workday math shares). */
export const isWeekend = (iso: string): boolean =>
  isWeekendDow(new Date(iso + "T00:00:00Z").getUTCDay());

/** Step an ISO date by ±1 workday (weekend-skipping; holidays are the
 *  backend's job — pushes are re-aligned to real workdays on write). */
export function stepWorkday(iso: string, dir: 1 | -1): string {
  const d = new Date(iso + "T00:00:00Z");
  do {
    d.setUTCDate(d.getUTCDate() + dir);
  } while (isWeekendDow(d.getUTCDay()));
  return d.toISOString().slice(0, 10);
}

/** Step an ISO date by n workdays (either direction). */
export function shiftWorkdays(iso: string, n: number): string {
  let d = iso;
  for (let i = 0; i < Math.abs(n); i++) d = stepWorkday(d, n > 0 ? 1 : -1);
  return d;
}

/** Inclusive workday span between two ISO dates: 1 when a === b, matching how
 *  the backend measures durations (finish = start + days − 1). */
export function workdaysBetween(a: string, b: string): number {
  if (!a || !b || b < a) return 1;
  let n = 1;
  let d = a;
  while (d < b) {
    d = stepWorkday(d, 1);
    n++;
  }
  return n;
}

/** Signed workday distance from a to b (0 when equal). */
export function workdayDelta(a: string, b: string): number {
  if (a === b) return 0;
  return b > a ? workdaysBetween(a, b) - 1 : -(workdaysBetween(b, a) - 1);
}
